import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../Field'
import { FormFieldSelectNG } from '../../../Form'
import { FormikField } from '../../../Formik'
import { ButtonSelect } from '../../../Select'
import { getSelectedAreaAccuracyOptions } from '../../DocFlow.utils.mapping'

function DocFlowMappingAccuracyField({
  disabled,
  label = 'DocumentStapling.SplittingMappingWidgetAccuracyFieldTitleKey',
  name,
  onChange,
  ...restProps
}) {
  const { t } = useTranslation()

  const accuracyOptions = getSelectedAreaAccuracyOptions(t)

  function handleChange(option) {
    onChange({ [name]: option })
  }

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={ButtonSelect}
      controlProps={{
        indicatorsProps: {
          ButtonClear: null,
        },
      }}
      disabled={disabled}
      fieldComponentProps={{
        label: t(label),
      }}
      name={name}
      options={accuracyOptions}
      onChange={handleChange}
    />
  )
}

export default DocFlowMappingAccuracyField
